export default {
      id: "delete-icon-usage",
      viewBox: "0 0 12 16",
      url: __webpack_public_path__ + "sprite.svg#delete-icon-usage",
      toString: function () {
        return this.url;
      }
    }